/**
 * Pulls in the assessment node data and mounts React.js application.
 */
import concat from 'lodash/concat';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import humps from 'lodash-humps';
import React from 'react';
import ReactDOM from 'react-dom';
import Goal from './Goal';

require('isomorphic-fetch');

(() => {
  /* global drupalSettings */
  const nodeId = drupalSettings.goals.nid;
  const categories = drupalSettings.goals.categories;
  let initialState;
  const timestampNow = Math.floor(Date.now() / 1000);
  if (sessionStorage.goalData) {
    const timestampLast = sessionStorage.goalTimestamp;
    if ((timestampNow - timestampLast) > 2700) {
      sessionStorage.removeItem('goalData');
      sessionStorage.removeItem('goalTimestamp');
    } else {
      initialState = JSON.parse(sessionStorage.goalData);
    }
  }
  // Retrieve entity object data
  fetch(`/api/goals/node/${nodeId}?_format=json`, {
    credentials: 'same-origin',
  }).then(response => response.json()).then((goalEntity) => {
    const sanitizedObject = humps(goalEntity[0]);
    const componentIds = sanitizedObject.fieldScreen.map(
      component => parseInt(component.targetId, 10),
    ).join('+');
    // Get components associated with the object.
    // These will not render correctly in the view, so making two calls
    // @TODO: configure views to provide a keyed array of paragraph entities
    fetch(`/api/goals/component/${componentIds}?_format=json`, {
      credentials: 'same-origin',
    }).then(response => response.json()).then((componentData) => {
      let sortedComponentData = [];
      // Sort component data in the same order that it is on the node.
      // @TODO: configure the view to spit out the data in the correct order
      forEach(goalEntity[0].field_screen, (step) => {
        const matching = filter(
          componentData,
          component => component.id[0].value === step.target_id,
        );
        sortedComponentData = concat(sortedComponentData, matching);
      });
      // Attach the app and pass in the component and entity data
      ReactDOM.render(
        <Goal
          componentData={humps(sortedComponentData)}
          goalCategories={categories}
          goalEntity={humps(goalEntity)}
          initialState={initialState}
        />,
        document.getElementById('goal-app'),
      );
    })
    .catch((ex) => {
      console.log('parsing failed', ex);
    });
  })
  .catch((ex) => {
    console.log('parsing failed', ex);
  });
})();



// WEBPACK FOOTER //
// js/src/goals/App.js